const translations = {
  en: {
    // Navbar
    'Operations': 'Operations',
    'Client Portal': 'Client Portal',
    'Rep View': 'Rep View',
    'Client View': 'Client View',
    // Client Dashboard
    'Welcome back': 'Welcome back',
    "You're % complete": "You're {pct}% complete",
    'Finish uploading required documents to move your application forward.': 'Finish uploading required documents to move your application forward.',
    'of': 'of',
    'categories submitted': 'categories submitted',
    'Upload Your Bank Statements': 'Upload Your Bank Statements',
    'Required to continue your application': 'Required to continue your application · Takes about 2 minutes',
    'Your Capital Infusion Representative': 'Your Capital Infusion Representative',
    'Financial Advisor': 'Financial Advisor',
    'We review documents immediately after upload.': 'We review documents immediately after upload. You\'ll hear from us soon.',
    'Required Documents': 'Required Documents',
    'View all': 'View all',
    'Required': 'Required',
    'Uploaded': 'Uploaded',
    'Not uploaded': 'Not uploaded',
    'What happens next?': 'What happens next?',
    'Upload your documents': 'Upload your documents',
    'Bank statements, ID, and voided check': 'Bank statements, ID, and voided check — it only takes a few minutes.',
    'We review immediately': 'We review immediately',
    'Our team begins reviewing': 'Our team begins reviewing as soon as your files are received.',
    'Receive your offer': 'Receive your offer',
    "We'll reach out with next steps": "We'll reach out with next steps and your funding options.",
    'Your information is 100% secure': 'Your information is 100% secure and confidential.',
    'Bank-level encryption': 'Bank-level encryption and industry-leading security keeps your data safe.',
    'Learn more about our security': 'Learn more about our security',
    // Tabs
    'Documents': 'Documents',
    'Requests': 'Requests',
    'Activity': 'Activity',
    'Notes': 'Notes',
    'Underwriting': 'Underwriting',
    'Auto Submit': 'Auto Submit',
    'Seasonality': 'Seasonality',
    'Application': 'Application',
    // Document categories
    'Bank Statements': 'Bank Statements',
    'Application': 'Application',
    "Driver's License": "Driver's License",
    'Voided Check': 'Voided Check',
    // Seasonality tab
    'Month': 'Month',
    'Year': 'Year',
    'Monthly Deposits': 'Monthly Deposits',
    'Deposits Per Month': 'Deposits Per Month',
    'Ledger ($)': 'Ledger ($)',
    'NSF': 'NSF',
    'No seasonality data available': 'No seasonality data available. Upload bank statements to populate.',
    // OCR
    'Send to OCR': 'Send to OCR',
    'Bank Type': 'Bank Type',
    'Select bank type...': 'Select bank type...',
    'OCR Unsupported': 'The OCR can only read statements from the listed banks at this time.',
    'Sending...': 'Sending...',
    'Sent!': 'Sent!',
    // Upload link
    'Upload Documents': 'Upload Documents',
    'Secure document upload': 'Secure document upload',
    'Drop files here or click to browse': 'Drop files here or click to browse',
    // General
    'Loading...': 'Loading...',
    'Continue': 'Continue',
    'Client Login': 'Client Login',
    'Access your application, upload documents, and track funding status.': 'Access your application, upload documents, and track funding status.',
    'Rep / Admin Login': 'Rep / Admin Login',
    'Manage clients, review documents, and oversee operations.': 'Manage clients, review documents, and oversee operations.',
    'Log In to Orbit': 'Log In to Orbit',
    'Access your secure portal to upload documents and check your application status.': 'Access your secure portal to upload documents and check your application status.',
    'Signing in...': 'Signing in...',
    'Folders': 'Folders',
    'Upload': 'Upload',
    'Download All': 'Download All',
    'Delete All': 'Delete All',
    'Deleting...': 'Deleting...',
    'files': 'files',
    'file': 'file',
    'Missing': 'Missing',
    'Request': 'Request',
    'Sent': 'Sent',
    'All': 'All',
    'Add Account': 'Add Account',
    'Search files...': 'Search files...',
    'No files in this category yet': 'No files in this category yet',
    'Drop files above to upload to S3': 'Drop files above to upload to S3',
    'Custom Request': 'Custom Request',
    'Send a document request to this client': 'Send a document request to this client',
    'Document Type': 'Document Type',
    'Due Date': 'Due Date',
    'Send Request': 'Send Request',
    'Instructions (optional)': 'Instructions (optional)',
    'No pending requests': 'No pending requests.',
    'Mark Done': 'Mark Done',
    'No activity recorded': 'No activity recorded for this client yet.',
    'No internal notes': 'No internal notes.',
    'Primary Action': 'Primary Action',
    // ClientLogin page
    'Welcome to Orbit': 'Welcome to Orbit',
    'Your secure portal to upload documents, communicate with your advisor, and move your funding forward —': 'Your secure portal to upload documents, communicate with your advisor, and move your funding forward —',
    'quickly and safely': 'quickly and safely',
    'Final Step: Upload Your Documents': 'Final Step: Upload Your Documents',
    'You\'re almost done! This is the last step in your application process. It takes about 2 minutes.': 'You\'re almost done! This is the last step in your application process. It takes about 2 minutes.',
    'Secure & Encrypted': 'Secure & Encrypted',
    'Direct Communication': 'Direct Communication',
    'Message your advisor': 'Message your advisor',
    'Faster Reviews': 'Faster Reviews',
    'Documents reviewed quickly': 'Documents reviewed quickly',
    // Client table columns
    'Business': 'Business',
    'Owner': 'Owner',
    'Assigned Rep': 'Assigned Rep',
    'Status': 'Status',
    'Last Activity': 'Last Activity',
    'Docs': 'Docs',
    'All Statuses': 'All Statuses',
    'Most Recent Activity': 'Most Recent Activity',
    'Least Recent Activity': 'Least Recent Activity',
    'Client Logged In': 'Client Logged In',
    'Application Completed': 'Application Completed',
    'Working': 'Working',
    'Inactive': 'Inactive',
    'Complete': 'Complete',
    // Pre-Pitch Calculator
    'Pre-Pitch Funding Intelligence': 'Pre-Pitch Funding Intelligence',
    'Evaluate funding capacity, pricing tier, repayment structure, and underwriting confidence before speaking with a merchant.': 'Evaluate funding capacity, pricing tier, repayment structure, and underwriting confidence before speaking with a merchant.',
    'RCCTI Scoring': 'RCCTI Scoring',
    'Monthly Revenue': 'Monthly Revenue',
    'Credit Score': 'Credit Score',
    'Bank Health': 'Bank Health',
    'Time in Business': 'Time in Business',
    'Industry Risk': 'Industry Risk',
    'Stated Information': 'Stated Information',
    'Industry': 'Industry',
    'Stated Monthly Revenue': 'Stated Monthly Revenue',
    'Existing Positions ($)': 'Existing Positions ($)',
    'Funding Tier': 'Funding Tier',
    'Confidence': 'Confidence',
    'Estimated Approval Range': 'Estimated Approval Range',
    'Multiplier': 'Multiplier',
    'Max Funding': 'Max Funding',
    'Best Factor': 'Best Factor',
    'Terms': 'Terms',
    'Repayment Structure': 'Repayment Structure',
    'Term': 'Term',
    'Factor': 'Factor',
    'Payback': 'Payback',
    'Daily': 'Daily',
    'Weekly': 'Weekly',
    'Underwriting Score Breakdown': 'Underwriting Score Breakdown',
  },
  es: {
    'Operations': 'Operaciones',
    'Client Portal': 'Portal del Cliente',
    'Rep View': 'Vista Rep',
    'Client View': 'Vista Cliente',
    'Welcome back': 'Bienvenido de nuevo',
    "You're % complete": "Estás {pct}% completo",
    'Finish uploading required documents to move your application forward.': 'Termina de subir los documentos requeridos para avanzar tu solicitud.',
    'of': 'de',
    'categories submitted': 'categorías enviadas',
    'Upload Your Bank Statements': 'Sube Tus Estados de Cuenta',
    'Required to continue your application': 'Requerido para continuar tu solicitud · Toma unos 2 minutos',
    'Your Capital Infusion Representative': 'Tu Representante de Capital Infusion',
    'Financial Advisor': 'Asesor Financiero',
    'We review documents immediately after upload.': 'Revisamos los documentos inmediatamente después de subirlos. Te contactaremos pronto.',
    'Required Documents': 'Documentos Requeridos',
    'View all': 'Ver todos',
    'Required': 'Requerido',
    'Uploaded': 'Subido',
    'Not uploaded': 'No subido',
    'What happens next?': '¿Qué sigue?',
    'Upload your documents': 'Sube tus documentos',
    'Bank statements, ID, and voided check': 'Estados de cuenta, identificación y cheque anulado — solo toma unos minutos.',
    'We review immediately': 'Revisamos inmediatamente',
    'Our team begins reviewing': 'Nuestro equipo comienza a revisar tan pronto como se reciben tus archivos.',
    'Receive your offer': 'Recibe tu oferta',
    "We'll reach out with next steps": "Te contactaremos con los próximos pasos y tus opciones de financiamiento.",
    'Your information is 100% secure': 'Tu información es 100% segura y confidencial.',
    'Bank-level encryption': 'Encriptación de nivel bancario y seguridad líder en la industria mantiene tus datos seguros.',
    'Learn more about our security': 'Más sobre nuestra seguridad',
    'Documents': 'Documentos',
    'Requests': 'Solicitudes',
    'Activity': 'Actividad',
    'Notes': 'Notas',
    'Underwriting': 'Suscripción',
    'Auto Submit': 'Envío Automático',
    'Seasonality': 'Estacionalidad',
    'Application': 'Solicitud',
    'Bank Statements': 'Estados de Cuenta',
    "Driver's License": 'Licencia de Conducir',
    'Voided Check': 'Cheque Anulado',
    'Other': 'Otro',
    'Month': 'Mes',
    'Year': 'Año',
    'Monthly Deposits': 'Depósitos Mensuales',
    'Deposits Per Month': 'Depósitos por Mes',
    'Ledger ($)': 'Saldo ($)',
    'NSF': 'NSF',
    'No seasonality data available': 'No hay datos de estacionalidad disponibles. Sube estados de cuenta para llenar.',
    'Send to OCR': 'Enviar a OCR',
    'Bank Type': 'Tipo de Banco',
    'Select bank type...': 'Seleccionar tipo de banco...',
    'OCR Unsupported': 'El OCR solo puede leer estados de cuenta de los bancos listados en este momento.',
    'Sending...': 'Enviando...',
    'Sent!': '¡Enviado!',
    'Upload Documents': 'Subir Documentos',
    'Secure document upload': 'Subida segura de documentos',
    'Drop files here or click to browse': 'Arrastra archivos aquí o haz clic para buscar',
    'Loading...': 'Cargando...',
    'Continue': 'Continuar',
    'Client Login': 'Inicio de Sesión Cliente',
    'Access your application, upload documents, and track funding status.': 'Accede a tu solicitud, sube documentos y rastrea el estado de tu financiamiento.',
    'Rep / Admin Login': 'Inicio Rep / Admin',
    'Manage clients, review documents, and oversee operations.': 'Gestiona clientes, revisa documentos y supervisa operaciones.',
    'Log In to Orbit': 'Iniciar Sesión en Orbit',
    'Access your secure portal to upload documents and check your application status.': 'Accede a tu portal seguro para subir documentos y verificar el estado de tu solicitud.',
    'Signing in...': 'Iniciando sesión...',
    'Folders': 'Carpetas',
    'Upload': 'Subir',
    'Download All': 'Descargar Todo',
    'Delete All': 'Eliminar Todo',
    'Deleting...': 'Eliminando...',
    'files': 'archivos',
    'file': 'archivo',
    'Missing': 'Faltante',
    'Request': 'Solicitar',
    'Sent': 'Enviado',
    'All': 'Todos',
    'Add Account': 'Agregar Cuenta',
    'Search files...': 'Buscar archivos...',
    'No files in this category yet': 'No hay archivos en esta categoría aún',
    'Drop files above to upload to S3': 'Arrastra archivos arriba para subir a S3',
    'Custom Request': 'Solicitud Personalizada',
    'Send a document request to this client': 'Enviar solicitud de documento a este cliente',
    'Document Type': 'Tipo de Documento',
    'Due Date': 'Fecha Límite',
    'Send Request': 'Enviar Solicitud',
    'Instructions (optional)': 'Instrucciones (opcional)',
    'No pending requests': 'No hay solicitudes pendientes.',
    'Mark Done': 'Marcar Hecho',
    'No activity recorded': 'No hay actividad registrada para este cliente.',
    'No internal notes': 'No hay notas internas.',
    'Primary Action': 'Acción Principal',
    // Sidebar
    'Dashboard': 'Panel',
    'Clients': 'Clientes',
    'Activity': 'Actividad',
    'Training': 'Capacitación',
    'Pre-Pitch Calc': 'Calc Pre-Pitch',
    'Client Data': 'Datos de Clientes',
    'Client Logins': 'Accesos de Clientes',
    'My Orbit': 'Mi Orbit',
    'My Documents': 'Mis Documentos',
    'Upload Center': 'Centro de Subida',
    'Requests': 'Solicitudes',
    'Messages': 'Mensajes',
    'Profile': 'Perfil',
    'My Businesses': 'Mis Negocios',
    'Line of Credit': 'Línea de Crédito',
    'complete': 'completo',
    'Welcome to Orbit': 'Bienvenido a Orbit',
    'Your secure portal to upload documents, communicate with your advisor, and move your funding forward —': 'Tu portal seguro para subir documentos, comunicarte con tu asesor y avanzar tu financiamiento —',
    'quickly and safely': 'rápida y seguramente',
    'Final Step: Upload Your Documents': 'Paso Final: Sube Tus Documentos',
    'You\'re almost done! This is the last step in your application process. It takes about 2 minutes.': '¡Ya casi terminas! Este es el último paso de tu solicitud. Toma unos 2 minutos.',
    'Secure & Encrypted': 'Seguro y Encriptado',
    'Direct Communication': 'Comunicación Directa',
    'Message your advisor': 'Mensaje a tu asesor',
    'Faster Reviews': 'Revisiones Rápidas',
    'Documents reviewed quickly': 'Documentos revisados rápidamente',
    // Client table columns
    'Business': 'Negocio',
    'Owner': 'Propietario',
    'Assigned Rep': 'Rep Asignado',
    'Status': 'Estado',
    'Last Activity': 'Última Actividad',
    'Docs': 'Docs',
    'All Statuses': 'Todos los Estados',
    'Most Recent Activity': 'Actividad Más Reciente',
    'Least Recent Activity': 'Actividad Menos Reciente',
    'Client Logged In': 'Cliente Inició Sesión',
    'Application Completed': 'Solicitud Completada',
    'Working': 'En Proceso',
    'Inactive': 'Inactivo',
    'Complete': 'Completo',
    // Pre-Pitch Calculator
    'Pre-Pitch Funding Intelligence': 'Inteligencia de Financiamiento Pre-Pitch',
    'Evaluate funding capacity, pricing tier, repayment structure, and underwriting confidence before speaking with a merchant.': 'Evalúa la capacidad de financiamiento, nivel de precios, estructura de pago y confianza de suscripción antes de hablar con un comerciante.',
    'RCCTI Scoring': 'Puntuación RCCTI',
    'Monthly Revenue': 'Ingresos Mensuales',
    'Credit Score': 'Puntaje de Crédito',
    'Bank Health': 'Salud Bancaria',
    'Time in Business': 'Tiempo en Negocio',
    'Industry Risk': 'Riesgo de Industria',
    'Stated Information': 'Información Declarada',
    'Industry': 'Industria',
    'Stated Monthly Revenue': 'Ingresos Mensuales Declarados',
    'Existing Positions ($)': 'Posiciones Existentes ($)',
    'Funding Tier': 'Nivel de Financiamiento',
    'Confidence': 'Confianza',
    'Estimated Approval Range': 'Rango de Aprobación Estimado',
    'Multiplier': 'Multiplicador',
    'Max Funding': 'Financiamiento Máximo',
    'Best Factor': 'Mejor Factor',
    'Terms': 'Plazos',
    'Repayment Structure': 'Estructura de Pago',
    'Term': 'Plazo',
    'Factor': 'Factor',
    'Payback': 'Reembolso',
    'Daily': 'Diario',
    'Weekly': 'Semanal',
    'Underwriting Score Breakdown': 'Desglose de Puntuación',
  },
  fr: {
    'Operations': 'Opérations',
    'Client Portal': 'Portail Client',
    'Rep View': 'Vue Rep',
    'Client View': 'Vue Client',
    'Welcome back': 'Bienvenue',
    "You're % complete": "Vous êtes à {pct}% complété",
    'Finish uploading required documents to move your application forward.': 'Terminez de télécharger les documents requis pour faire avancer votre demande.',
    'of': 'de',
    'categories submitted': 'catégories soumises',
    'Upload Your Bank Statements': 'Téléchargez Vos Relevés Bancaires',
    'Required to continue your application': 'Requis pour continuer votre demande · Prend environ 2 minutes',
    'Your Capital Infusion Representative': 'Votre Représentant Capital Infusion',
    'Financial Advisor': 'Conseiller Financier',
    'We review documents immediately after upload.': 'Nous examinons les documents immédiatement après le téléchargement. Vous aurez de nos nouvelles bientôt.',
    'Required Documents': 'Documents Requis',
    'View all': 'Voir tout',
    'Required': 'Requis',
    'Uploaded': 'Téléchargé',
    'Not uploaded': 'Non téléchargé',
    'What happens next?': 'Que se passe-t-il ensuite?',
    'Upload your documents': 'Téléchargez vos documents',
    'Bank statements, ID, and voided check': "Relevés bancaires, pièce d'identité et chèque annulé — cela ne prend que quelques minutes.",
    'We review immediately': 'Nous examinons immédiatement',
    'Our team begins reviewing': 'Notre équipe commence à examiner dès que vos fichiers sont reçus.',
    'Receive your offer': 'Recevez votre offre',
    "We'll reach out with next steps": "Nous vous contacterons avec les prochaines étapes et vos options de financement.",
    'Your information is 100% secure': 'Vos informations sont 100% sécurisées et confidentielles.',
    'Bank-level encryption': 'Chiffrement de niveau bancaire et sécurité de pointe pour protéger vos données.',
    'Learn more about our security': 'En savoir plus sur notre sécurité',
    'Documents': 'Documents',
    'Requests': 'Demandes',
    'Activity': 'Activité',
    'Notes': 'Notes',
    'Underwriting': 'Souscription',
    'Auto Submit': 'Soumission Auto',
    'Seasonality': 'Saisonnalité',
    'Application': 'Demande',
    'Bank Statements': 'Relevés Bancaires',
    "Driver's License": 'Permis de Conduire',
    'Voided Check': 'Chèque Annulé',
    'Other': 'Autre',
    'Month': 'Mois',
    'Year': 'Année',
    'Monthly Deposits': 'Dépôts Mensuels',
    'Deposits Per Month': 'Dépôts par Mois',
    'Ledger ($)': 'Solde ($)',
    'NSF': 'NSF',
    'No seasonality data available': 'Aucune donnée de saisonnalité disponible. Téléchargez des relevés bancaires.',
    'Send to OCR': 'Envoyer à OCR',
    'Bank Type': 'Type de Banque',
    'Select bank type...': 'Sélectionner le type de banque...',
    'OCR Unsupported': "L'OCR ne peut lire que les relevés des banques listées pour le moment.",
    'Sending...': 'Envoi...',
    'Sent!': 'Envoyé!',
    'Upload Documents': 'Télécharger Documents',
    'Secure document upload': 'Téléchargement sécurisé de documents',
    'Drop files here or click to browse': 'Déposez les fichiers ici ou cliquez pour parcourir',
    'Loading...': 'Chargement...',
    'Continue': 'Continuer',
    'Client Login': 'Connexion Client',
    'Access your application, upload documents, and track funding status.': 'Accédez à votre demande, téléchargez des documents et suivez votre financement.',
    'Rep / Admin Login': 'Connexion Rep / Admin',
    'Manage clients, review documents, and oversee operations.': 'Gérez les clients, examinez les documents et supervisez les opérations.',
    'Log In to Orbit': 'Se Connecter à Orbit',
    'Access your secure portal to upload documents and check your application status.': 'Accédez à votre portail sécurisé pour télécharger des documents et vérifier votre demande.',
    'Signing in...': 'Connexion en cours...',
    'Folders': 'Dossiers',
    'Upload': 'Télécharger',
    'Download All': 'Tout Télécharger',
    'Delete All': 'Tout Supprimer',
    'Deleting...': 'Suppression...',
    'files': 'fichiers',
    'file': 'fichier',
    'Missing': 'Manquant',
    'Request': 'Demander',
    'Sent': 'Envoyé',
    'All': 'Tous',
    'Add Account': 'Ajouter Compte',
    'Search files...': 'Rechercher fichiers...',
    'No files in this category yet': 'Aucun fichier dans cette catégorie',
    'Drop files above to upload to S3': 'Déposez les fichiers ci-dessus pour télécharger',
    'Custom Request': 'Demande Personnalisée',
    'Send a document request to this client': 'Envoyer une demande de document à ce client',
    'Document Type': 'Type de Document',
    'Due Date': 'Date Limite',
    'Send Request': 'Envoyer Demande',
    'Instructions (optional)': 'Instructions (optionnel)',
    'No pending requests': 'Aucune demande en attente.',
    'Mark Done': 'Marquer Fait',
    'No activity recorded': "Aucune activité enregistrée pour ce client.",
    'No internal notes': 'Aucune note interne.',
    'Primary Action': 'Action Principale',
    // Sidebar
    'Dashboard': 'Tableau de Bord',
    'Clients': 'Clients',
    'Activity': 'Activité',
    'Training': 'Formation',
    'Pre-Pitch Calc': 'Calc Pré-Pitch',
    'Client Data': 'Données Clients',
    'Client Logins': 'Connexions Clients',
    'My Orbit': 'Mon Orbit',
    'My Documents': 'Mes Documents',
    'Upload Center': 'Centre de Téléchargement',
    'Requests': 'Demandes',
    'Messages': 'Messages',
    'Profile': 'Profil',
    'My Businesses': 'Mes Entreprises',
    'Line of Credit': 'Ligne de Crédit',
    'complete': 'complété',
    'Welcome to Orbit': 'Bienvenue sur Orbit',
    'Your secure portal to upload documents, communicate with your advisor, and move your funding forward —': 'Votre portail sécurisé pour télécharger des documents, communiquer avec votre conseiller et faire avancer votre financement —',
    'quickly and safely': 'rapidement et en toute sécurité',
    'Final Step: Upload Your Documents': 'Dernière Étape: Téléchargez Vos Documents',
    'You\'re almost done! This is the last step in your application process. It takes about 2 minutes.': 'Vous avez presque terminé! C\'est la dernière étape de votre demande. Cela prend environ 2 minutes.',
    'Secure & Encrypted': 'Sécurisé et Chiffré',
    'Direct Communication': 'Communication Directe',
    'Message your advisor': 'Messagez votre conseiller',
    'Faster Reviews': 'Révisions Rapides',
    'Documents reviewed quickly': 'Documents examinés rapidement',
    // Client table columns
    'Business': 'Entreprise',
    'Owner': 'Propriétaire',
    'Assigned Rep': 'Rep Assigné',
    'Status': 'Statut',
    'Last Activity': 'Dernière Activité',
    'Docs': 'Docs',
    'All Statuses': 'Tous les Statuts',
    'Most Recent Activity': 'Activité la Plus Récente',
    'Least Recent Activity': 'Activité la Moins Récente',
    'Client Logged In': 'Client Connecté',
    'Application Completed': 'Demande Complétée',
    'Working': 'En Cours',
    'Inactive': 'Inactif',
    'Complete': 'Complet',
    // Pre-Pitch Calculator
    'Pre-Pitch Funding Intelligence': 'Intelligence de Financement Pré-Pitch',
    'Evaluate funding capacity, pricing tier, repayment structure, and underwriting confidence before speaking with a merchant.': 'Évaluez la capacité de financement, le niveau de prix, la structure de remboursement et la confiance de souscription avant de parler à un commerçant.',
    'RCCTI Scoring': 'Notation RCCTI',
    'Monthly Revenue': 'Revenus Mensuels',
    'Credit Score': 'Score de Crédit',
    'Bank Health': 'Santé Bancaire',
    'Time in Business': 'Ancienneté',
    'Industry Risk': "Risque d'Industrie",
    'Stated Information': 'Informations Déclarées',
    'Industry': 'Industrie',
    'Stated Monthly Revenue': 'Revenus Mensuels Déclarés',
    'Existing Positions ($)': 'Positions Existantes ($)',
    'Funding Tier': 'Niveau de Financement',
    'Confidence': 'Confiance',
    'Estimated Approval Range': "Fourchette d'Approbation Estimée",
    'Multiplier': 'Multiplicateur',
    'Max Funding': 'Financement Maximum',
    'Best Factor': 'Meilleur Facteur',
    'Terms': 'Termes',
    'Repayment Structure': 'Structure de Remboursement',
    'Term': 'Terme',
    'Factor': 'Facteur',
    'Payback': 'Remboursement',
    'Daily': 'Quotidien',
    'Weekly': 'Hebdomadaire',
    'Underwriting Score Breakdown': 'Détail du Score',
  },
};

export default translations;
